<template>
  <b-table
    :data="data"
    :loading="loading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column field="id" label="Ativo">
        <b-icon
          v-if="props.row.active"
          size="is-small"
          icon="check"
          type="is-success"
        ></b-icon>
        <b-icon
          v-if="!props.row.active"
          size="is-small"
          icon="cancel"
          type="is-danger"
        ></b-icon>
      </b-table-column>
      <b-table-column field="name" label="Nome">{{
        props.row.name
      }}</b-table-column>
      <b-table-column field="start_at" label="Início">{{
        props.row.start_at | date
      }}</b-table-column>
      <b-table-column field="end_at" label="Encerramento">{{
        props.row.end_at | date
      }}</b-table-column>
      <b-table-column label="Opções">
        <router-link
          tag="button"
          :to="{
            name: 'campaign-points.index',
            params: { campaignId: props.row.id },
          }"
          v-app-button.icon-only
          v-tooltip.bottom="'Pontos'"
        >
          <b-icon size="is-small" icon="trophy-variant"></b-icon>
        </router-link>
        <button
          @click="edit(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Editar'"
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </button>
        <button
          @click="onClickCopyCampaign(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Duplicar campanha'"
        >
          <b-icon size="is-small" icon="checkbox-multiple-blank"></b-icon>
        </button>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import CampaignService from '@/services/campaign.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'campaign-table',
  mixins: [ToastMixin],
  data: () => {
    return {
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.loading = true;

      CampaignService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;
          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastfy('Erro ao carregar Campanhas.', 'error'))
        .finally(() => (this.loading = false));
    },
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onClickCopyCampaign(id) {
      this.$buefy.dialog.confirm({
        title: 'Copiando campanha',
        message: 'Tem certeza que deseja <b>copiar</b> esta campanha?',
        cancelText: 'Cancelar',
        confirmText: 'Copiar campanha',
        type: 'is-primary',
        hasIcon: true,
        onConfirm: () => this.copyCampaign(id),
      });
    },
    copyCampaign(id) {
      this.loading = true;
      CampaignService.copy(id)
        .then(() => {
          this.loading = false;
          this.toastify('Campanha copiada com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar copiar Campanha.',
            'error'
          );
        });
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
